import React,{Component} from "react";

import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  
} from "shards-react";

import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import firebase from '../firebase';

export default class ClassList extends Component{

  constructor(props) {
    super(props);
  
    this.state = {selected:undefined,loading:false,class_list:[]};

    this.getStyle = this.getStyle.bind(this);
    this.ChangeSelect = this.ChangeSelect.bind(this);
    this.get_class_list = this.get_class_list.bind(this);
  }

  ChangeSelect=(id)=>{
    this.setState({selected:id});
    this.props.set_class(id)
  }

  
  get_class_list = ()=>{
      var that = this;
      this.setState({loading:true});
      firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          that.setState({loading:false,class_list:class_list});
      }).catch(function(err){
          that.setState({loading:false});
          toast('Unable to get class list !', {containerId: 'A'});
      })
  }

  componentDidMount(){
    this.get_class_list();
  }



  getStyle = (id,type) =>{
      
      if(this.state.selected===id){
          if(type==="background"){
            return {backgroundColor: '#4169e1'}
          }
          if(type==="word"){
            return {color: 'white'}
          }
      }

      if(type==="background"){
            return {backgroundColor: 'white'}
      }
      if(type==="word"){
            return {color: 'black'}
      }
    
  }

  render(){
    return(
     <Card small className="mb-4 pt-3">
        <CardHeader className="border-bottom text-center">
        <h4 className="mb-0">{"Classes"}</h4>
    </CardHeader>
    <ListGroup flush className={"scroll_list-group"}>
            
            {
              !this.state.loading
                &&
                   ( this.state.class_list.map((item,i)=>{
                      return <ClassItem  data={item} 
                                    key={i} 
                                    index={i+1} 
                                    getStyle={this.getStyle}
                                    ChangeSelect={this.ChangeSelect}
                                    />
                    })
                  )
            }
            {
              (!this.state.loading && this.state.class_list.length===0)
                &&

                <NoClass />

            }

            {
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />         
                    </div>
          }
      
    </ListGroup>
  </Card>
      )
  }
}



class ClassItem extends Component{
  render(){
    return(
   
      <ListGroupItem className="px-4"  style={this.props.getStyle(this.props.data,'background')} onClick={()=>{this.props.ChangeSelect(this.props.data)}}>
        <div className="progress-wrapper" style={this.props.getStyle(this.props.data,'word')}>
          <strong className=" d-block mb-2">
            {this.props.data}
          </strong>
        </div>
      </ListGroupItem>
      )
  }
}


class NoClass extends Component{
  render(){
    return(
      <ListGroupItem className="px-4"  style={{backgroundColor: 'white'}} >
        <div className="progress-wrapper" style={{color: 'black'}}>
          <strong className=" d-block mb-2">
            {"No Available Class"}
          </strong>
        </div>
      </ListGroupItem>
    )
  }
}
